import {IMessage} from "@stomp/stompjs";
import {IHttpPromise, IHttpService} from "angular";
import {getAbsoluteUrl} from "../../utils/urlUtill";
import {SCHEDULES_API_URL} from "../const/schedulesConst";
import {QueuedTask} from "../../scheduling/model/QueuedTask";
import {WebSocketTopicName} from "../../websocket_service/model/WebSocketTopicName";
import {WebSocketServiceName} from "../../utils/names/serviceNames";
import {WebSocketService} from "../../websocket_service/service/WebSocketService";
import {Page} from "../../utils/models/Page";
import {QueuedTaskExecutionLog} from "../../scheduling/model/QueuedTaskExecutionLog";

export class QueuedTaskService {

    static instance = [
        '$http',
        WebSocketServiceName,
        QueuedTaskService
    ];

    constructor(private $http: IHttpService,
                private webSocketService: WebSocketService) {
    }

    pullExecutionQueue() {
        return this.$http({
            method: 'GET',
            url: getAbsoluteUrl(`${SCHEDULES_API_URL}/queue`)
        });
    }

    cancelQueuedTask = (task: QueuedTask): IHttpPromise<any> => {
        return this.$http({
            method: 'DELETE',
            url: getAbsoluteUrl(`${SCHEDULES_API_URL}/queue`),
            data: task
        });
    };

    startQueuedTasksSession = (messageCallback: (message: IMessage) => void) => {
        this.webSocketService.startSession(WebSocketTopicName.QUEUED_SCHEDULED_TASKS_TOPIC, messageCallback)
    };

    stopQueuedTasksSession = () => {
        this.webSocketService.stopSession(WebSocketTopicName.QUEUED_SCHEDULED_TASKS_TOPIC);
    };

    pullTaskExecutionLogs(number: number,size: number): IHttpPromise<Page<QueuedTaskExecutionLog>> {
        return this.$http({
            method: 'GET',
            url: getAbsoluteUrl(`${SCHEDULES_API_URL}/log`),
            params: {
                pageNumber: number,
                pageSize: size
            }
        })
    }
}